export interface EmailConfig {
  id?: number;
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_password?: string;    // write-only: solo se envía al guardar, nunca se recibe
  smtp_password_set?: boolean; // indica si hay contraseña guardada en el servidor
  use_tls: boolean;
  use_ssl: boolean;
  from_email: string;
  from_name: string;
  send_to_jefe: boolean;
  send_to_cliente: boolean;
  extra_recipients: string;
  cc_emails: string;
  subject_template: string;
  body_template: string;
  is_active: boolean;
}

export const DEFAULT_EMAIL_CONFIG: EmailConfig = {
  smtp_host: '',
  smtp_port: 587,
  smtp_user: '',
  smtp_password: '',
  use_tls: true,
  use_ssl: false,
  from_email: '',
  from_name: 'CAABSA',
  send_to_jefe: true,
  send_to_cliente: false,
  extra_recipients: '',
  cc_emails: '',
  subject_template: 'Solicitud de VoBo — {empresa} — {clienteNombre}',
  body_template:
    'Estimado/a {nombreJefe},\n\n' +
    'Por medio del presente, le informamos que el/la colaborador/a {clienteNombre} ' +
    'ha presentado una solicitud de crédito con los siguientes datos:\n\n' +
    '  • Empresa: {empresa}\n' +
    '  • Monto Solicitado: {monto}\n' +
    '  • Plazo: {plazo} meses\n' +
    '  • No. de Control: {numeroControl}\n\n' +
    'Solicitamos su VoBo para continuar con el proceso de autorización.\n\n' +
    'Atentamente,\n{asesor}\nCABSA',
  is_active: true,
};
